import { render, staticRenderFns } from "./PasswordChecker.vue?vue&type=template&id=545b113e&scoped=true"
import script from "./PasswordChecker.vue?vue&type=script&lang=js"
export * from "./PasswordChecker.vue?vue&type=script&lang=js"
import style0 from "./PasswordChecker.vue?vue&type=style&index=0&id=545b113e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545b113e",
  null
  
)

export default component.exports